import { css } from "@emotion/react";

export const img = css`
  div:first-child {
    width: 100%;
    height: 100%;
    max-height: calc(100dvh - 10.5rem);

    img {
      width: 100%;
      height: 100%;
      max-height: calc(100dvh - 10.5rem);
    }
  }
`;

export const modal = css`
  top: 0;
`;

export const carousel = css`
  margin: auto;
`;
export const carouselItem = css`
  justify-content: center;
  align-items: center;
`;

export const carouselArrows = css`
  position: absolute;
  top: calc(50% - 2rem);
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
